export default __webpack_public_path__ + "static/media/full-logo-shadow.b518f813.svg";